import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
            平台优势
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            我们的优势
          </h2>
          <p className="text-sm text-foreground-600 mt-2">为什么千万吃瓜群众选择每日吃瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70 group hover:border-primary-200 transition-colors duration-200 text-center"
            >
              <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i
                  className={`${item.icon} text-primary-500 text-2xl group-hover:text-white transition-colors duration-300`}
                ></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}